<template>
  <form-section>
    <p class="item-description">
      {{ $t('Integrations_Otp_Description') }}
    </p>
    <div v-if="model && model.id" class="service-id-row">
      <span class="service-id-label">
        {{ $t('Integrations_Otp_ServiceId_Label') }}:
      </span>
      <span class="service-id-value" ref="serviceId">{{ model.id }}</span>
      <i class="el-icon-copy-document service-id-copy" @click="copyServiceId" />
    </div>
  </form-section>
</template>

<script>
import FormSection from '@/common/components/form/FormSection.vue'

export default {
  name: 'OtpOverview',

  components: { FormSection },

  props: {
    model: {
      required: false
    }
  },

  methods: {
    copyServiceId() {
      navigator.clipboard
        .writeText(String(this.model.id))
        .then(() =>
          this.$message({
            message: this.$t('Integrations_Otp_ServiceId_Copied'),
            type: 'success'
          })
        )
        .catch(() =>
          this.$message.error(this.$t('Integrations_Otp_ServiceId_CopyFailed'))
        )
    }
  }
}
</script>

<style scoped>
.service-id-row {
  display: flex;
  align-items: center;
  margin-top: 12px;
}

.service-id-label {
  color: #606266;
  font-size: 14px;
}

.service-id-value {
  font-weight: 600;
  font-size: 14px;
  color: #333333;
  margin-left: 6px;
}

.service-id-copy {
  font-size: 16px;
  margin-left: 8px;
  color: #606266;
  cursor: pointer;
  transition: all 0.2s;
}

.service-id-copy:hover {
  color: #409eff;
  transform: scale(1.1);
}
</style>



// WEBPACK FOOTER //
// src/modules/integrations/types/otp/OtpOverview.vue